import { render, staticRenderFns } from "./keton.vue?vue&type=template&id=40836f84&"
import script from "./keton.vue?vue&type=script&lang=js&"
export * from "./keton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports